import React, { useState } from 'react'
import { Form, Link, usePage } from '@inertiajs/react'
import AuthLayout from '../../components/AuthLayout'
import registerBg from '../../../assets/images/IMAGEM 09 - MAPAS E POLOS HA.jpg'

export default function Register() {
  const { errors } = usePage().props
  const [processing, setProcessing] = useState(false)

  const userErrors = errors?.user || errors || {}

  return (
    <AuthLayout backgroundImage={registerBg}>
      <div className="text-center text-white">
        <h2 className="text-2xl font-bold mb-6">Crie sua conta</h2>

        <Form
          action="/users"
          method="post"
          options={{ forceFormData: true }}
          onStart={() => setProcessing(true)}
          onFinish={() => setProcessing(false)}
        >
          <div className="mb-4">
            <input
              type="email"
              name="user[email]"
              placeholder="Digite seu e-mail"
              className="w-full h-12 px-4 rounded-lg bg-white/65 text-gray-800 placeholder-gray-500 border-0 focus:ring-2 focus:ring-brand-light"
              autoFocus
              autoComplete="email"
            />
            {userErrors.email && (
              <div className="mt-1 text-red-300 text-sm text-left">{userErrors.email}</div>
            )}
          </div>

          <div className="mb-4">
            <input
              type="text"
              name="user[nome]"
              placeholder="Digite seu nome"
              className="w-full h-12 px-4 rounded-lg bg-white/65 text-gray-800 placeholder-gray-500 border-0 focus:ring-2 focus:ring-brand-light"
              autoComplete="given-name"
            />
            {userErrors.nome && (
              <div className="mt-1 text-red-300 text-sm text-left">{userErrors.nome}</div>
            )}
          </div>

          <div className="mb-4">
            <input
              type="text"
              name="user[sobrenome]"
              placeholder="Digite seu sobrenome"
              className="w-full h-12 px-4 rounded-lg bg-white/65 text-gray-800 placeholder-gray-500 border-0 focus:ring-2 focus:ring-brand-light"
              autoComplete="family-name"
            />
            {userErrors.sobrenome && (
              <div className="mt-1 text-red-300 text-sm text-left">{userErrors.sobrenome}</div>
            )}
          </div>

          <div className="mb-4">
            <input
              type="password"
              name="user[password]"
              placeholder="Digite sua senha (min: 6 caracteres)"
              className="w-full h-12 px-4 rounded-lg bg-white/65 text-gray-800 placeholder-gray-500 border-0 focus:ring-2 focus:ring-brand-light"
              autoComplete="new-password"
            />
            {userErrors.password && (
              <div className="mt-1 text-red-300 text-sm text-left">{userErrors.password}</div>
            )}
          </div>

          <div className="mb-4">
            <input
              type="password"
              name="user[password_confirmation]"
              placeholder="Confirme sua senha"
              className="w-full h-12 px-4 rounded-lg bg-white/65 text-gray-800 placeholder-gray-500 border-0 focus:ring-2 focus:ring-brand-light"
              autoComplete="new-password"
            />
            {userErrors.password_confirmation && (
              <div className="mt-1 text-red-300 text-sm text-left">{userErrors.password_confirmation}</div>
            )}
          </div>

          <div className="mb-6 text-sm">
            <Link href="/users/sign_in" className="hover:underline">
              Já possui uma conta? Entrar
            </Link>
          </div>

          <button
            type="submit"
            disabled={processing}
            className="w-full h-12 bg-brand-light hover:bg-brand-dark text-white font-medium rounded-lg transition-colors disabled:opacity-50"
          >
            {processing ? 'Criando...' : 'Criar conta'}
          </button>
        </Form>
      </div>
    </AuthLayout>
  )
}
